// extracted by mini-css-extract-plugin
export var linkhover = "post-module--linkhover--F38k+";
export var bottom = "post-module--bottom--1+rtl";
export var left = "post-module--left--uPRFC";
export var callout = "post-module--callout--eWJh1";
export var right = "post-module--right--UgIte";
export var link = "post-module--link--T97u1";
export var top = "post-module--top--srlt7";
export var moreblog = "post-module--moreblog--27-92";
export var logolink = "post-module--logolink--RWwJG";
export var lefttop = "post-module--lefttop--PtrQi";
export var faded = "post-module--faded--BtKf5";
export var logo = "post-module--logo--zvmCL";
export var patientname = "post-module--patientname--nJQbP";
export var leftbottom = "post-module--leftbottom--jBz5+";
export var patientheading = "post-module--patientheading--7uAt9";
export var request = "post-module--request--7IXiv";
export var bg = "post-module--bg--scMYp";
export var bgxl = "post-module--bgxl--dEL4Z";
export var bgxlfeatured = "post-module--bgxlfeatured--LtJTd";
export var bgdesktop = "post-module--bgdesktop--DIJ9l";
export var bgdesktopfeatured = "post-module--bgdesktopfeatured--wxwyX";
export var bgtablet = "post-module--bgtablet--qDwNh";
export var bgtabletfeatured = "post-module--bgtabletfeatured--yPqxC";
export var bgmobile = "post-module--bgmobile--7N8xR";
export var bgmobilefeatured = "post-module--bgmobilefeatured--1ebX2";
export var heading = "post-module--heading--HGBZL";
export var date = "post-module--date--AkJ5B";
export var insurance = "post-module--insurance--zXunI";
export var insurancebottom = "post-module--insurancebottom--OyruM";
export var insuranceimage = "post-module--insuranceimage--MwSuO";
export var blurb = "post-module--blurb--HCveP";
export var patientcontent = "post-module--patientcontent--57vpF";
export var contentleft = "post-module--contentleft--ryP1x";
export var linkcards = "post-module--linkcards--gKUNM";
export var linkcard = "post-module--linkcard--OxZlk";
export var title = "post-module--title--r2pLz";
export var cta = "post-module--cta--+lAl4";
export var ctacopy = "post-module--ctacopy--9ULpU";
export var iconyellow = "post-module--iconyellow--dN44U";
export var icongray = "post-module--icongray--KZRhz";